import React, {Component} from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import classnames from 'classnames';

import I18nText from '../../i18n/I18nText';
import {FormattedMessage} from "react-intl";

/**
 * Basis-Klasse für Widget-Komponenten, die Inputs repräsentieren.
 *
 * Generell sollte es ausreichen, wenn abgeleitete Komponenten die render() Methode implementieren.
 */
class InputWidget extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * @returns {*}
     */
    getInputLabel() {
        return this.props.widget.label;
    }

    /**
     * @returns {string|undefined}
     */
    getValue() {
        const value = _.get(this.props.formikProps.values, this.getFieldName());
        return (_.isNull(value) || _.isUndefined(value)) ? '' : value;
    }

    /**
     * @returns {undefined}
     */
    getError() {
        return _.get(this.props.formikProps.errors, this.getFieldName());
    }

    /**
     * @returns {any}
     */
    getTouched() {
        return _.get(this.props.formikProps.touched, this.getFieldName());
    }

    /**
     * @returns {boolean}
     */
    isRequired() {
        return this.props.widget.required;
    }

    /**
     * Prüft für custom widgets, ob diese fachlich required und nicht befüllt sind, sobald diese betreten wurden
     *
     * @return {any|boolean}
     */
    isCustomRequiredAndInvalid() {
        if (
            !this.props.callForPapers.form.allowPartialSubmissions
            || !this.props.formikProps
            || !this.props.formikProps.values
        ) {
            return false;
        }

        const value = this.props.formikProps.values.widgets[this.props.widget.id];
        if (Array.isArray(value)) {
            // hier muss wohl auf dirty geprüft werden, da es bei solchen Elementen kein touched gibt..?
            return this.isRequired() && this.props.formikProps.dirty && value.length === 0;
        }

        return this.isRequired() && this.getTouched() && (value === null || value === "");
    }

    /**
     * Gibt eine Fehlermeldung aus, wenn ein custom widget required ist und touched wurde
     *
     * @return {JSX.Element}
     */
    getCustomRequiredError() {
        // TODO die widgets sind mit widgets.<id> getagged, so kannst eventuell stylen
        if (this.isCustomRequiredAndInvalid()) {
            return <span style={{color: "#ff0000"}} data-testid={"required-error-" + this.props.widget.id}>
                    <FormattedMessage id="submission.form.custom.required"/>
                </span>;
        }
    }

    /**
     * @returns {*|boolean}
     */
    isInvalid() {
        // Fehlermeldungen wollen wir anzeigen, wenn das Feld ungültig ist UND der Benutzer in irgendeiner Weise damit
        // interagiert hat. Leider bietet Formik auf Feldebene nicht die Möglichkeit auf "dirtiness" zu prüfen, daher
        // behelfen wir uns mit dem "touched" Flag und setzen onChange das Feld explizit auf "touched", damit das
        // gewünschte Verhalten entsteht.
        return this.getTouched() && !!this.getError();
    }

    /**
     * @param event
     */
    handleChange(event) {
        // Bei Änderungen das Feld explizit als "touched" kennzeichnen, die Validierung
        // aber unterdrücken, da diese ohnehin durch handleChange getriggert wird.
        this.props.formikProps.setFieldTouched(this.getFieldName(), true, false);
        if (event.currentTarget.type === "number") {
            // Sonderlocke, da es sonst als String an die API geschickt wird und diese meckert
            this.props.formikProps.setFieldValue(this.getFieldName(), event.currentTarget.valueAsNumber);
        } else {
            // setzen des Wertes, standard formik handleChange mag checkboxes/radiobuttons nicht, welche Initalwerte haben
            this.props.formikProps.setFieldValue(this.getFieldName(), event.currentTarget.value);
        }
    }

    /**
     * @returns {string}
     */
    getFieldName() {
        return `widgets.${this.props.widget.id}`;
    }

    /**
     * @returns {JSX.Element}
     */
    renderLabelText() {
        const isRequired = this.isRequired() || this.props.widget.baseWidget;
        return (
            <I18nText className={classnames({required: isRequired})} content={this.getInputLabel()}/>
        )
    }

    /**
     * @param event
     */
    handleBlur = (event) => {
        this.props.formikProps.handleBlur(event);
    };

}

InputWidget.propTypes = {
    widget: PropTypes.object,
    formikProps: PropTypes.object
};

export default InputWidget;
